<template>
  <div class="preview">
    <div class="preview__stage">
      <CharacterPreview :appearance="finalAppearance" :equipped="equipped" />
    </div>

    <div class="preview__slots">
      <div v-for="slot in visibleSlots" :key="slot.key" class="preview__slot" :class="{ 'preview__slot--empty': !slot.item }">
        <span class="preview__slot-name">{{ slot.item?.title || slot.label }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import CharacterPreview from "./CharacterPreview.vue"
import type { PlayerAppearance } from "../shared/types"
import type { ShopItemDto } from "../shared/shopTypes"

const props = defineProps<{
  appearance: PlayerAppearance
  equipped: ShopItemDto[]
}>()

function findBySlot(slot: string): ShopItemDto | undefined {
  return props.equipped.find((it) => it.slot === slot)
}

const visibleSlots = computed(() => [
  { key: "hat", label: "Шапка", item: findBySlot("hat") },
  { key: "face", label: "Лицо", item: findBySlot("face") },
  { key: "piercing", label: "Пирсинг", item: findBySlot("piercing") },
  { key: "neck", label: "Шея", item: findBySlot("neck") },
  { key: "outerwear", label: "Верх", item: findBySlot("outerwear") },
  { key: "bottom", label: "Низ", item: findBySlot("bottom") },
  { key: "shoes", label: "Обувь", item: findBySlot("shoes") },
  { key: "back", label: "Спина", item: findBySlot("back") },
  { key: "pet", label: "Питомец", item: findBySlot("pet") },
])

const finalAppearance = computed<PlayerAppearance>(() => props.appearance)
</script>

<style scoped>
.preview {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.preview__stage {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(137, 184, 232, 0.24) 0%, rgba(135, 166, 106, 0.2) 100%);
}

.preview__slots {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  gap: 6px;
}
.preview__slot {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #F6F2E9;
  border-radius: 10px;
  padding: 6px 10px;
  font-size: 11px;
  font-weight: 700;
  color: #6258D9;
}
.preview__slot--empty {
  opacity: 0.4;
}
.preview__slot-icon {
  font-size: 14px;
}
.preview__slot-name {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
